<template>
  <div class="clientComments">
    <slot />
    <client-single-comment v-for="(comment, index) in comments" :index="index" :key="comment.id" :comment="comment">{{ comment.text }}</client-single-comment>
    <client-comment-form :updateNotification="handleUpdateNotification" />
  </div>
</template>

<script>
import ClientSingleComment from './client-single-comment'
import ClientCommentForm from './client-comment-form'

export default {
  name: 'ClientComments',
  components: {
    ClientSingleComment,
    ClientCommentForm
  },
  props: {},
  mounted () {
  },
  data: () => ({
    notifications: [],
    comments: [
      {
        id: 1,
        name: 'Jo',
        lastSeen: {
          location: 'Cupertino, CA',
          date: '04 Feb 2018 00:01:00 GMT'
        },
        text: 'Hello Stevie, I was wondering if we could change the header please?'
      },
      {
        id: 2,
        name: 'Steve',
        lastSeen: {
          location: 'Portland',
          date: '05 Feb 2018 00:01:00 GMT'
        },
        text: 'Hi Daniel, I\'ve changed the image for you!'
      },
      {
        id: 3,
        name: 'Jo',
        lastSeen: {
          location: 'Cupertino, CA',
          date: '04 Feb 2018 00:01:00 GMT'
        },
        text: 'Hello Stevie, I was wondering if we could change the header please?'
      },
      {
        id: 4,
        name: 'Steve',
        lastSeen: {
          location: 'Portland',
          date: '05 Feb 2018 00:01:00 GMT'
        },
        text: 'Hi Daniel, I\'ve changed the image for you!'
      }
    ]
  }),
  methods: {
    handleUpdateNotification (message) {
      const notification = [ { type: 'danger', message: { title: 'Error', body: message } } ]
      this.notifications = message ? notification : null
    }
  }
}
</script>

<style lang="scss">
    @import "./client-comments";
</style>



// WEBPACK FOOTER //
// src/components/ClientComments/client-comments.vue